import { AfterViewChecked, ChangeDetectorRef, ElementRef, Inject, Injectable, Renderer2, ViewContainerRef, createComponent } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ChatPost } from '../http/chatPost';
import { ResponseGeneric } from '../http/responseGeneric';
import { EmailPost } from '../http/emailPost';
import { ResponseComponent } from '../chatResponse/response/response.component';
import { UserResponseComponent } from '../userResponse/user-response/user-response.component';
import { CSSStyle } from '../http/cssStyle';
import { CssService } from './css.service';
import { DOCUMENT } from '@angular/common';
import { expand } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class DataService {
    //Sends data to API and create an instance of response component with the API response

    askType = "text" //this changes when a button is pressed like set map 
    mapIndex = 0;
    isTyping = false
    tabIndex = 0
    sessionID: string = ""
    confirmAddress: string = ""
    expandIndex = 0;
    render?: Renderer2
    isExpanded?: boolean
    isCurrentlyExpanding = false
    disclaimer = ""
    root: any;

    constructor(private http: HttpClient, public cssService: CssService, @Inject(DOCUMENT) private document: Document,
    ) {
        const app = document.getElementsByTagName('app-q11bot')[0];
        this.root = app.shadowRoot ? app.shadowRoot : this.document
    }

    checkExpandView(isExpanded: boolean, render: Renderer2, chattingWrapper: ElementRef) {
        const movingDivs = this.root.querySelectorAll('.expand-chat')
        const expandChat = this.root.querySelector('.chat-expand') as HTMLElement
        const display = window.getComputedStyle(expandChat).display

        if (Array.prototype.slice.call(movingDivs).length > 0 && !this.isCurrentlyExpanding && display == 'block') {
            this.isCurrentlyExpanding = true
            this.updateExpandedView(!this.isCurrentlyExpanding, render, chattingWrapper)
        }
        if (display == 'block') {
            expandChat.scrollTop = expandChat.scrollHeight;
        }
    }

    updateExpandedView(isExpanded: boolean, render: Renderer2, chattingWrapper: ElementRef) {
        const logoRemove = this.root.querySelectorAll('.expandHide')
        const updateMaps = this.root.querySelectorAll('.expanded-view');
        const expandChat = this.root.querySelector('.chat-expand') as HTMLElement
        const copyElements = this.root.querySelectorAll('.expand-chat');
        if (isExpanded) {
            Array.prototype.slice.call(logoRemove).forEach((element: HTMLElement) => {
                element.style.display = 'block'
            })
            Array.prototype.slice.call(updateMaps).forEach((element: HTMLElement) => {
                const regex = /expandChatIndex(\d+)/;
                const match = element.className.match(regex)?.length ? element.className.match(regex)![0] : element.className.match(regex)!;
                if (match) {
                    const replacementDiv = this.root.querySelectorAll(`.${match}.clone`)!
                    const parentDiv = replacementDiv[0].parentElement
                    Array.prototype.slice.call(parentDiv?.children).forEach(child => {
                        if (child.className.indexOf('clone') != -1) {
                            parentDiv?.removeChild(child)
                        }
                    });
                    render.removeClass(element, 'expanded-view')
                    parentDiv?.append(element)
                }
            })
            this.scrollToBottom(chattingWrapper)
            isExpanded = false
        } else {
            Array.prototype.slice.call(logoRemove).forEach((element: HTMLElement) => {
                element.style.display = 'none'
            })
            Array.prototype.slice.call(copyElements).forEach((element: HTMLElement) => {
                if (element.className.indexOf("expand-chat") != -1 && element.className.indexOf("expanded-view") == -1 && element.className.indexOf('clone') == -1) {
                    const parentDiv = element.parentElement
                    const clone = element.cloneNode(false)
                    render.addClass(clone, 'clone')
                    parentDiv!.append(clone)
                    render.addClass(element, "expanded-view")
                    expandChat.appendChild(element)
                }
            });

            isExpanded = true
        }
        return isExpanded
    }

    sendMessage(data: string) {
        this.isTyping = true
        const url = this.cssService.properties!.api_url + '/askchat'
        const askmessage = data
        const postData = new ChatPost(this.sessionID, askmessage, this.askType, this.cssService.properties!.chat_agent_id)
        return this.http.post<ResponseGeneric>(url, postData)
    }

    postMessage(adminMessage: string, targetDiv: ViewContainerRef, changeView: ChangeDetectorRef, chattingWrapper: ElementRef, properties?: CSSStyle, expandedView?: ViewContainerRef,) {
        if (this.isTyping) {
            return []
        }
        if (this.askType == "email") {
            this.tabIndex = 3
            this.askType = 'text'
            return []
        } else {
            this.sendMessage(adminMessage).subscribe(
                data => {
                    if (data.responseinerror == 'y') { //Error occured 
                        var allResponseType: string[] = [];
                        const child = targetDiv.createComponent(ResponseComponent);
                        child.instance.targetDiv = targetDiv!
                        child.instance.chattingWrapper = chattingWrapper
                        child.instance.allResponseType = allResponseType
                        child.instance.mapIndex = this.mapIndex
                        child.instance.properties = properties
                        child.instance.allResponseType = ["response-error"]
                        this.updateAskType("text")
                        this.isTyping = false
                        changeView.markForCheck()
                    } else {
                        //Successful Post
                        let responses: { [key: string]: string } = data.response
                        let allResponseInfoArray: { [key: string]: string }[][] = [];
                        var allResponseType: string[] = [];

                        for (let i = 0; i < Object.keys(responses).length; ++i) {
                            let messageType = Object.keys(responses[i])[0]
                            allResponseType.push(messageType)
                            //Add the response to a double array to make sure every returned data is similar
                            if (!Object.values(responses[i])[0][0]) {
                                allResponseInfoArray.push([Object.values(responses[i])[0]] as unknown as [{ [key: string]: any }])
                            } else {
                                allResponseInfoArray.push(Object.values(responses[i])[0] as unknown as [{ [key: string]: any }])
                            }
                        }

                        const child = targetDiv.createComponent(ResponseComponent);
                        child.instance.targetDiv = targetDiv!
                        child.instance.chattingWrapper = chattingWrapper
                        child.instance.allResponseInfoArray = allResponseInfoArray
                        child.instance.allResponseType = allResponseType
                        child.instance.mapIndex = this.mapIndex
                        child.instance.expandIndex = this.expandIndex
                        child.instance.properties = properties
                        if (this.askType == 'start') {
                            this.disclaimer = data.disclaimer
                        }
                        this.updateAskType("text")
                        this.isTyping = false
                        changeView.markForCheck()
                        this.scrollToBottom(chattingWrapper)
                    }
                },
                () => {
                    //Post Erro
                    const child = targetDiv.createComponent(ResponseComponent);
                    child.instance.properties = properties
                    let messageType = "network-error"
                    child.instance.allResponseType = [messageType]
                    this.updateAskType("text")
                    this.isTyping = false
                    changeView.markForCheck()
                    this.scrollToBottom(chattingWrapper)
                    return []
                })
        }
        return
    }

    createResponseNoPost(url: string, targetDiv: ViewContainerRef, changeView: ChangeDetectorRef, chattingWrapper: ElementRef, properties?: CSSStyle, expandedView?: ViewContainerRef,) {
        //If a response already had a gogole url and the user clicks to show on map with the existing googleurl
        const child = targetDiv.createComponent(ResponseComponent);
        child.instance.targetDiv = targetDiv!
        child.instance.chattingWrapper = chattingWrapper
        let arrayInfo: any = {
            "expand": true,
            "type": "map",
            "google-url": url
        }
        child.instance.allResponseInfoArray = [[arrayInfo]]
        child.instance.allResponseType = ["map-card"]
        child.instance.expandIndex = this.expandIndex
        child.instance.properties = properties
        this.updateAskType("text")
        this.isTyping = false
        changeView.markForCheck()
    }

    userMessage(targetDiv: ViewContainerRef, adminMessage: string, changeView: ChangeDetectorRef, chattingWrapper: ElementRef) {
        if (!this.isTyping) {
            const userChat = targetDiv!.createComponent(UserResponseComponent)
            userChat.instance.adminMessage = adminMessage
            changeView.markForCheck()
            this.scrollToBottom(chattingWrapper)
        }
    }

    sendEmail(data: { [key: string]: string }) {
        const url = this.cssService.properties!.api_url + '/askchat'
        const postData = new EmailPost(this.sessionID, data, this.cssService.properties!.chat_agent_id)
        return this.http.post<ResponseGeneric>(url, postData)
    }

    updateAskType(askType: string) {
        this.askType = askType
    }

    updateMapIndex(mapIndex: number) {
        this.mapIndex = mapIndex + 1
    }

    scrollToBottom(chattingWrapper: ElementRef) {
        if (chattingWrapper) {
            const chattingWrapperDiv = chattingWrapper.nativeElement;
            if (chattingWrapperDiv) {
                chattingWrapperDiv.scrollTop = chattingWrapperDiv.scrollHeight;
            }
        }
    }

    randomSessionID(length: number) {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            result += characters.charAt(randomIndex);
        }
        this.sessionID = result;
    }
}